import { NavigationPath } from 'src/models/navigation/navigation.path.enum';

export enum OrderStatus {
	new = 0,
	accepted = 1,
	paid = 2,
	markedForExport = 3,
	exported = 4,
	shipped = 5,
	invoiced = 6,
	cancelled = 7,
}


// status to path double mapped -> need to go both ways
// used for getting the path-segment for a specific order-status
export const OrderStatusNavigationPath = new Map<OrderStatus, NavigationPath>([
	[OrderStatus.new, NavigationPath.new],
	[OrderStatus.paid, NavigationPath.paid],
	[OrderStatus.accepted, NavigationPath.inProgress],
	[OrderStatus.exported, NavigationPath.inProgress],
	[OrderStatus.markedForExport, NavigationPath.inProgress],
	[OrderStatus.shipped, NavigationPath.shipped],
	[OrderStatus.invoiced, NavigationPath.invoiced],
	[OrderStatus.cancelled, NavigationPath.cancelled],
]);

// status to path double mapped -> need to go both ways
// used for Order-Filter
export const NavigationPathOrderStatusFilter = new Map<NavigationPath, OrderStatus[]>([
	[NavigationPath.new, [OrderStatus.new]],
	[NavigationPath.paid, [OrderStatus.paid]],
	[NavigationPath.inProgress, [OrderStatus.accepted, OrderStatus.exported, OrderStatus.markedForExport]],
	[NavigationPath.shipped, [OrderStatus.shipped]],
	[NavigationPath.invoiced, [OrderStatus.invoiced]],
	[NavigationPath.cancelled, [OrderStatus.cancelled]],
	[NavigationPath.all, []], // all status - no filter
	[NavigationPath.inReview, []] // all status, but with review -> order-filter-service handles this
]);


